$(document).ready(function () {
  $(".filter-checkbox")
    .off()
    .change(function () {
      var newURL = $(this).nextAll("a").attr("href");
      window.location.href = newURL;
    });

  const sortArray = (array) => {
    array = array.sort((a, b) => a - b);
    return array;
  };
  const groupBySizeRegion = (filters) => {
    let objectNumber = {};
    filters.forEach((filter) => {
      let splitFilter = filter.split(" "),
        sizeType =
          splitFilter.length == 2
            ? splitFilter[0]
            : splitFilter.length == 3
              ? `${splitFilter[0]} ${splitFilter[1]}`
              : splitFilter.length == 1
                ? `Size`
                : null,
        sizeNumber =
          splitFilter.length == 2
            ? splitFilter[1]
            : splitFilter.length == 3
              ? splitFilter[2]
              : splitFilter.length == 1
                ? splitFilter[0]
                : null;
      if (typeof objectNumber[sizeType] === "undefined") {
        objectNumber[sizeType] = [sizeNumber];
      } else {
        objectNumber[sizeType] = [...objectNumber[sizeType], sizeNumber];
      }
    });
    return objectNumber;
  };
  const getFilterWithLetter = (filters) => {
    filters = filters.filter((filter) => {
      let splitFilter = filter.split(" "),
        sizeNumber = parseFloat(splitFilter[1]);
      if (sizeNumber != splitFilter[1]) return filter;
    });
    return filters;
  };
  const getFilterNumber = (filters) => {
    filters = filters.filter((filter) => {
      let splitFilter = filter.split(" "),
        sizeNumber = parseFloat(splitFilter[1]);
      if (sizeNumber == splitFilter[1]) return filter;
    });
    return filters;
  };
  const getSortedFilterNumber = (filterNumber) => {
    let objectNumber;
    if (filterNumber.length > 0) {
      objectNumber = groupBySizeRegion(filterNumber);
      for (item in objectNumber) {
        objectNumber[item] = objectNumber[item].map((val) => {
          return parseFloat(val);
        });
        objectNumber[item] = sortArray(objectNumber[item]);
      }
      return objectNumber;
    }
  };
  const getSortedFilterWithLetter = (filterNumberLetter) => {
    let objectNumberLetter;
    if (filterNumberLetter.length > 0) {
      objectNumberLetter = groupBySizeRegion(filterNumberLetter);
      console.log(objectNumberLetter);
      for (item in objectNumberLetter) {
        let newGroup = {};
        objectNumberLetter[item].forEach((val) => {
          let lastChar = val[val.length - 1],
            isContainLetter = isNaN(parseFloat(lastChar)) ? true : false;
          if (isContainLetter) {
            //       	newArray = [...newArray, [val.replace(lastChar, ""), lastChar]]
            if (typeof newGroup[lastChar] === "undefined") {
              newGroup[lastChar] = [val];
            } else {
              newGroup[lastChar] = [...newGroup[lastChar], val];
            }
          }
        });
        if (Object.keys(newGroup).length > 0) {
          let keyLetter = [];
          for (key in newGroup) {
            keyLetter = [...keyLetter, key];
          }
          keyLetter.sort();
          let sortNewGroup = {};
          keyLetter.forEach((index) => {
            sortNewGroup[index] = newGroup[index];
          });
          for (key in sortNewGroup) {
            sortNewGroup[key] = sortNewGroup[key].map((valNewgroup) => {
              let lastChar = valNewgroup[valNewgroup.length - 1];
              return [valNewgroup.replace(lastChar, ""), lastChar];
            });
            sortNewGroup[key] = sortNewGroup[key].sort(
              (a, b) => parseFloat(a[0]) - parseFloat(b[0])
            );
            sortNewGroup[key] = sortNewGroup[key].map((valNewgroup) => {
              let lastChar = valNewgroup[valNewgroup.length - 1];
              return `${valNewgroup[0]}${valNewgroup[1]}`;
            });
          }
          objectNumberLetter[item] = sortNewGroup;
        } else {
          objectNumberLetter[item] = objectNumberLetter[item].map((val) => {
            return parseFloat(val);
          });
          objectNumberLetter[item] = sortArray(objectNumberLetter[item]);
        }
      }
    }
    return objectNumberLetter;
  };
  const concatObject = (objectNumber, objectNumberLetter) => {
    if (typeof objectNumber !== "undefined") {
      if (Object.keys(objectNumber).length > 0) {
        for (key in objectNumber) {
          if (typeof objectNumberLetter !== "undefined") {
            if (Object.keys(objectNumberLetter).length > 0) {
              for (index in objectNumberLetter) {
                if (key === index) {
                  if (Array.isArray(objectNumberLetter[index])) {
                    objectNumber[key] = objectNumber[key].concat(
                      objectNumberLetter[index]
                    );
                  } else {
                    for (idx in objectNumberLetter[index]) {
                      objectNumber[key] = objectNumber[key].concat(
                        objectNumberLetter[index][idx]
                      );
                    }
                  }
                } else {
                  if (typeof objectNumber[index] === "undefined") {
                    objectNumber[index] = objectNumberLetter[index];
                  }
                }
              }
            }
          }
        }
      }
    } else if (typeof objectNumberLetter !== "undefined") {
      if (Object.keys(objectNumberLetter).length > 0) {
        return objectNumberLetter;
      }
    }
    return objectNumber;
  };
  const appendFilter = (concatedObject, obj, sizeType, currentUrl) => {
    let objectHTML = concatedObject[obj].map((item) => {
      let itemUrl = item
        .toString()
        .replaceAll(" ", "-")
        .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
      let filterHTML;
      if (obj == "BR") {
        filterHTML = `
                  <li class="filter-item size-digit-keatas size-${obj}-${item}">
                    <a href="${currentUrl}/size-${sizeType}-${itemUrl}-${parseFloat(item) + 1
          }" title="Narrow selection to products matching tag size-${sizeType} ${item}/${parseFloat(item) + 1
          }">${obj} ${item}/${parseFloat(item) + 1}</a>    
                  </li>	
              `;
      } else {
        if (sizeType.toLowerCase() != "size") {
          filterHTML = `
                    <li class="filter-item size-digit-keatas size-${obj}-${item}">
                        <a href="${currentUrl}/size-${sizeType}-${itemUrl}" title="Narrow selection to products matching tag size-${sizeType} ${item}">${obj} ${item}</a>    
                    </li>	
                `;
        } else {
          if (item != 0) {
            filterHTML = `
                    <li class="filter-item size-digit-keatas selain-size">
                        <a href="${currentUrl}/size-${itemUrl}" title="Narrow selection to products matching tag size ${item}">${obj} ${item}</a>    
                    </li>	
                `;
          }
        }
      }
      return filterHTML;
    });
    return objectHTML;
  };
  let currentUrl = location.protocol + "//" + location.host + location.pathname,
    currentUrlSplit = currentUrl.split("/");
  currentUrl =
    currentUrlSplit.length > 5
      ? location.protocol +
      "//" +
      location.host +
      "/" +
      currentUrlSplit[3] +
      "/" +
      currentUrlSplit[4]
      : currentUrl;
  if (
    location.pathname.includes("collections") &&
    !location.pathname.includes("products")
  ) {
    let filters = [];
    size.forEach((val) => {
      filters = [...filters, val];
    });
    console.log(size);
    filters = filters.map((item) => {
      if (item.split(" ") > 1) {
        return `Size ${item}`;
      } else {
        return item;
      }
    });
    let filterNumber = getFilterNumber(filters);
    let filterNumberLetter = getFilterWithLetter(filters);

    let objectNumber = getSortedFilterNumber(filterNumber);
    let objectNumberLetter = getSortedFilterWithLetter(filterNumberLetter);
    let concatedObject = concatObject(objectNumber, objectNumberLetter);
    for (obj in concatedObject) {
      let sizeType = obj
        .replaceAll(" ", "-")
        .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-"),
        objectHTML;
      console.log(obj);
      if (Array.isArray(concatedObject[obj])) {
        objectHTML = appendFilter(concatedObject, obj, sizeType, currentUrl);
        let containerFilterHTML = `
          <ul class="filter-list 2digit_keatas duakeatas type-${obj.toLowerCase()}">
              ${objectHTML.join("\n")}
          </ul>
        `;
        if (obj == "Size" && window.location.pathname.includes("bags-1")) {
          $("#filterClothing .filter-title").text("Accessories Size");
        }
        if (
          obj === "Size" &&
          window.location.pathname.includes("accessories-1")
        ) {
          $("#filterClothing .filter-title").text("Accessories Size");
        }
        if (obj === "Size" && window.location.pathname.includes("apparel")) {
          $("#filterClothing .filter-title").text("Clothing Size");
        }
        if (obj == "UK" || obj == "US" || obj == "US W") {
          $("#filterTitlena").text("Footwear Size");
        }
        $("#sizeFilterna .filter-panel").append(containerFilterHTML);
      } else {
        for (key in concatedObject[obj]) {
          objectHTML = concatedObject[obj][key].map((item) => {
            let itemUrl = item
              .toString()
              .replaceAll(" ", "-")
              .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
            let filterHTML;
            if (obj == "BR") {
              filterHTML = `
                    <li class="filter-item size-digit-keatas size-${item}">
                      <a href="${currentUrl}/size-${sizeType}-${itemUrl}-${parseFloat(item) + 1
                }" title="Narrow selection to products matching tag size-${sizeType} ${item}/${parseFloat(item) + 1
                }">${obj} ${item}/${parseFloat(item) + 1}</a>    
                    </li>	
                `;
            } else if (obj == "NS") {
  
            } else {
              if (sizeType.toLowerCase() != "size") {
                filterHTML = `
                      <li class="filter-item size-digit-keatas size-${item}">
                          <a href="${currentUrl}/size-${sizeType}-${itemUrl}" title="Narrow selection to products matching tag size-${sizeType} ${item}">${obj} ${item}</a>    
                      </li>	
                  `;
              } else {
                if (item != 0) {
                  filterHTML = `
                      <li class="filter-item size-digit-keatas selain-size">
                          <a href="${currentUrl}/size-${itemUrl}" title="Narrow selection to products matching tag size ${item}">${obj} ${item}</a>    
                      </li>	
                  `;
                }
              }
            }
            return filterHTML;
          });
          let containerFilterHTML = `
          <ul class="filter-list 2digit_kebawah duakeatas type-${obj.toLowerCase()}">
              ${objectHTML.join("\n")}
          </ul>
          `;
          $("#filterClothing .filter-panel .filter-list").append(
            `${objectHTML.join("\n")}`
          );
        }
      }
    }
  }
});